import asyncActionTypes from '../actions/types';

const initialState = {
  touchPointType: 'myb',
};

const TouchPointCpProperty = (state = initialState, action) => {
  if (action.type === asyncActionTypes.TOUCH_POINT_PROPERTY_CP) {
    return {
      ...state,
      touchPointType: action.touchPoint,
    };
  } else {
    return state;
  }
};

export default TouchPointCpProperty;